import React from 'react';

import { PlanStateContext } from '../PlanStateContext';

export const usePlanApplyMetricBellow = () => {
  const {
    api: { onApplyMetricBellow },
  } = React.useContext(PlanStateContext);

  return onApplyMetricBellow;
};
